import { formatDateTimeBR, plural } from "~/utils/format";

// D2: o contrato manda `from: number[]`, mas um número solto é aceito (defensivo).
const toArray = (value) => (Array.isArray(value) ? value : value == null ? [] : [value]);
const tags = (ids) => ids.map((id) => `#${id}`);

const AUTO_DETAIL = {
  auto_arrival: "Regra: pacote novo chegou e havia outro do mesmo médico e empresa ainda não conferido",
  auto_completion:
    "Regra: a empresa concluiu e havia outro pacote do mesmo médico e empresa aguardando contrato com a mesma data de pagamento",
};

const authorOf = (move) => {
  if (move.source === "manual") return `Manual · ${move.actorName || "time interno"}`;
  if (move.source === "company_complete") return "Empresa médica";
  return "Automático";
};

export const describeMove = (move, packageId) => {
  const from = toArray(move.from).map(Number);
  const to = Number(move.to);
  const self = Number(packageId);
  // formatDateTimeBR(null) cairia em 1970: sem data, sem texto.
  const at = move.createdAt ? formatDateTimeBR(move.createdAt) : "";
  const n = Number(move.vacancies) || 0;
  if (move.type === "merge" && to === self) {
    const how = move.source === "manual" ? "manualmente" : "automaticamente";
    return {
      kind: "merge",
      at,
      title: `Juntado ${how}: ${tags(from).join(" + ")} → #${to}`,
      detail: move.source === "manual" ? authorOf(move) : AUTO_DETAIL[move.source] || "Automático",
    };
  }
  if (move.type === "merge") {
    return {
      kind: "merge",
      at,
      title: `Encerrado: agrupado no #${to}`,
      // `vacancies` é o total do batch: só vale como contagem desta origem quando ela é a única.
      detail:
        from.length === 1
          ? `${authorOf(move)} · ${plural(n, "plantão seguiu", "plantões seguiram")} para o #${to}`
          : `${authorOf(move)} · os plantões seguiram para o #${to}`,
    };
  }
  if (to === self) {
    return {
      kind: "split",
      at,
      title: `Dividido: ${tags(from).join(" + ")} → #${to}`,
      detail: `Empresa enviou o ${tags(from).join(", ")} com ${plural(n, "plantão marcado", "plantões marcados")} para não antecipar agora`,
    };
  }
  return {
    kind: "split",
    at,
    title: `Dividido: ${plural(n, "plantão foi", "plantões foram")} para o #${to}`,
    detail: "Empresa marcou para não antecipar agora",
  };
};

export const describeHistory = (moves, packageId) =>
  [...moves]
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((move) => ({ key: `${move.batchId}-${move.type}`, ...describeMove(move, packageId) }));

export const mergedIntoFromMoves = (moves, packageId) => {
  const self = Number(packageId);
  const move = moves.find((m) => m.type === "merge" && toArray(m.from).map(Number).includes(self));
  return move ? Number(move.to) : null;
};
